<template>
  <div class="titlebar" :class="[variantClass, { 'has-totals': hasTotals, 'has-buttons': hasButtons, 'has-pre': hasPretitle }]">
    <div class="title-wrap">
        <div class="pagetitle">
          <div class="pagetitle--pre">
            <slot name="pretitle" />
          </div>
          <div class="pagetitle--main">
            <h2><slot name="title">Title</slot></h2>
          </div>
          <slot name="subtitle" />
        </div>
        <div class="action-bar">
            <slot name="buttons"></slot>
        </div>
    </div>
    <div class="totals">
        <slot name="totals"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TitleBar",
  props: {
    variantClass: {
      type: String,
      default: 'primary'
    },
  },
  computed: {
    hasPretitle() {
      return !!this.$slots['pretitle']
    },
    hasButtons() {
      return !!this.$slots['buttons']
    },
    hasTotals() {
      return !!this.$slots['totals']
    }
  }
};
</script>
<style lang="scss">
.titlebar {
  .action-bar {
    display: flex;
    flex: 1;
    position: relative;
    white-space: nowrap;
    align-items: center;
    justify-content: flex-end;
    min-height: 50px;
  }
  .totals {
    margin-left: auto;
  }
  &.has-pre {
    .pagetitle {
      &--pre {
        margin-bottom: 0.25rem;
      }
    }
  }
  &.has-totals {
    .action-bar {
      justify-content: flex-start;
    }
    &.has-buttons {
      @media(min-width: '768px') {
        .action-bar {
          margin-left: 4rem;
          &:before {
            content: '';
            background: #e4e4e4;
            width: 1px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: -2rem;
            height: 50%;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.titlebar {
  display: flex;
  padding: 1.5rem 1rem;
  padding-bottom: 1rem;
  position: relative;
  background: transparent;
  justify-content: space-between;
  flex-direction: column;

  .title-wrap {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    flex-direction: column;
    gap: 0.5rem;
  }
  .pagetitle {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    h2 { font-size: 28px; margin-bottom: 0; line-height: 1; }
    &--pre, &--sub {
      font-size: 14px;
      opacity: 0.6;
    }
    &--pre {
      text-transform: uppercase;
    }
    &--main {
      display: flex;
      align-items: baseline;
    }
  }
  
  &.title-modal {
    justify-content: space-between;
    padding: 0;
    margin-bottom: 20px;
    width: 100%;
    h2 { margin: 0; font-size: 26px; }

    border-top-left-radius: $radiusLg;
    border-top-right-radius: $radiusLg;
    
    .action-bar {
      flex: auto;
    }

    &.has-buttons {
      .action-bar {
        margin-top: 0.25rem;
      }
    }

    &:not(.title-modal--simple) {
      .action-bar {
        align-items: flex-end;
        justify-content: flex-start;
        .modal-action-bar {
          display: flex;
          gap: 0.5rem;
          flex-wrap: wrap;
          .btn {
            background: white;
            border: none;
            border-radius: 8px;
            font-size: 1rem;
            border: 1px solid #d1d5db;
            &:hover {
              background: #e5e7eb;
            }
          }
        }
      }
      @media (min-width: '576px') {
        background: #f3f4f5;
        width: calc(100% + 1rem);
        padding: 0.5rem;
        margin: -0.5rem;
        margin-bottom: 1rem;
        .action-bar {
          justify-content: flex-end;
        }
      }
      @media (min-width: '768px') {
        width: calc(100% + 2rem);
        padding: 1rem;
        margin: -1rem;
        margin-bottom: 1rem;
      }
    }
  }
  @media (min-width: '576px') {
    flex-direction: row;
    flex-flow: row wrap;
    .title-wrap {
      flex-direction: row;
    }
  }
}
</style>

<style lang="scss">

</style>